import { GET_REQUESTS_API } from '../../config/constant/apiConstant';
import { paginatedRequestsActions } from "../../redux/slicers/admin/paginatedRequests";
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from '../apiGenerator';

export const getRequestsPageListApi = createGetListAction({
  endpoint: GET_REQUESTS_API,
  actions: paginatedRequestsActions,
  setGlobalSidebarFilters: true,
});

export const deleteRequestsAPI = createDeleteApiAction({
  actions: paginatedRequestsActions,
  endpointUrl: GET_REQUESTS_API,
  optimistic: false,
  successMessage: 'The File is deleted successfully',
})

export const requestsUpdateApi = createUpdateApiAction({
  actions: paginatedRequestsActions,
  endpointUrl: GET_REQUESTS_API,
})